module.exports = __webpack_public_path__ + "assets/9be6056f2c928c0c8f3fd8be42ff45b7.svg";